<template>
    <v-select ref="categorySelect" :items="filteredCategories" v-model="selectedCategory" item-value="id"
        item-text="name" label="Training Category" class="course_type mb-4" filled attach dense return-object clearable
        :filter="customFilter" @change="resetSearchTerm" hide-no-data :loading="categoryLoading"
        :disabled="categoryLoading">
        <!-- Tooltip -->
        <template slot="append-outer">
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on">fa fa-question</v-icon>
                </template>
                <span>Select a pre-assigned training category from the dropdown or add a new training category.</span>
            </v-tooltip>
        </template>
        <template #progress>
                            <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
            </template>
        <!-- Search Input -->
        <template #prepend-item>
            <v-list-item>
                <v-list-item-content style="padding: 12px 0 0 0;">
                    <v-text-field v-model="searchTerm" label="Search Category" @input="onSearchInput"
                        class="search-term" style="margin:0;" />
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>

            <!-- Add New Category -->
            <v-list-item>
                <v-list-item-content>
                    <v-text-field v-if="addingNew" v-model="newCategory" dense autofocus class="add-new-category-input"
                        style="cursor: text;" />
                    <v-list-item-title v-else @click="toggleAdding(true)" class="add-new-category">
                        <v-icon left>mdi-plus-circle-outline</v-icon>
                        Add New Category
                    </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="addingNew" class="category-action-btn">
                    <v-btn icon small @click.stop="addNewCategory" color="primary">
                        <v-icon>mdi-checkbox-multiple-marked-circle-outline</v-icon>
                    </v-btn>
                    <v-btn icon small @click.stop="toggleAdding(false)" color="error">
                        <v-icon>mdi-close-circle-multiple-outline</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
        </template>

        <!-- Editable Category List -->
        <template #selection="{ item }">
            <div class="category-item">
                {{ item.name }}
            </div>
        </template>

        <template #item="{ item }">
            <v-list-item>
                <v-list-item-content>
                    <v-text-field v-if="editingItem === item" v-model="editName" dense autofocus />
                    <v-list-item-title v-else @click="selectCategory(item)">
                        {{ item.name }}
                    </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="editingItem !== item" class="category-action-btn">
                    <v-btn icon small @click.stop="startEditCategory(item)" color="primary" v-if="item.is_default === 0">
                        <v-icon>mdi-pencil-circle-outline</v-icon>
                    </v-btn>
                    <v-btn icon small @click.stop="deleteCategory(item)" color="error"  v-if="item.is_default === 0">
                        <v-icon>mdi-delete-circle-outline</v-icon>
                    </v-btn>
                </v-list-item-action>
                <v-list-item-action v-else class="category-action-btn">
                    <v-btn icon small @click.stop="confirmEditCategory(item)" color="primary" v-if="item.is_default === 0">
                        <v-icon>mdi-checkbox-multiple-marked-circle-outline</v-icon>
                    </v-btn>
                    <v-btn icon small @click.stop="closeEdit" color="error" v-if="item.is_default === 0">
                        <v-icon>mdi-close-circle-multiple-outline</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
        </template>
    </v-select>
</template>

<script>
import externalAPI from "@/api/external.js";
import { EventBus } from "@/event-bus.js";
export default {
    props: {
    cat: {
      type: Object,
      default: null
    },
    },
    data() {
        return {
            categories: [],
            searchTerm: "",
            newCategory: "",
            addingNew: false,
            editingItem: null,
            editName: "",
            categoryLoading: false,
            categoryDeleteSuccessMessage: 'Category has been removed successfully',
            cateogryErrorMessage: 'Oops, something went wrong!',       
        };
    },
    computed: {
        filteredCategories() {
            if (!this.searchTerm) {
                return this.categories;
            }
            return this.categories.filter(category =>
                category.name.toLowerCase().includes(this.searchTerm.toLowerCase())
            );
        },
        selectedCategory: {
            get() {
                    return this.cat; // Read the prop value
                },
                set(value) {
                    EventBus.$emit("SELECTED_TRAINING_CATEGORY", value);
                }
        }
    },
    mounted() {
    this.getExternalTrainingCategories();
    },
    methods: {
        getExternalTrainingCategories() {
            this.categoryLoading = true;
        externalAPI.getExternalTrainingCategories().then(response => {
            this.categories = response.data.data;
            this.categoryLoading = false;
        });
        },
        customFilter(item, search) {
        // This can be customized as needed for advanced filtering
        return item.name.toLowerCase().includes(search.toLowerCase());
        },
        onSearchInput() {
            // Triggered when user types in the search field
        },
        resetSearchTerm() {
            this.searchTerm = "";
        },
        toggleAdding(isAdding) {
            if (isAdding) {
                this.addingNew = true;
            } else {
                this.addingNew = false;
                this.newCategory = '';
            }
        },
        addNewCategory() {
            if (this.newCategory.trim()) {
                this.categoryLoading = true;
                externalAPI.addExternalTrainingCategory({ name: this.newCategory.trim() }).then(() => {
                    this.getExternalTrainingCategories();
                    EventBus.$emit("TRAINING_CATEGORY_UPDATED");
                })
                    .catch(() => {
                        this.$snotify.error(this.cateogryErrorMessage);
                        this.categoryLoading = false;
                        setTimeout(() => {
                            this.$gf.removeBackdrop();
                        }, 300);
                    });
                this.newCategory = "";
            }
            this.addingNew = false;
        },
        selectCategory(category) {
            this.selectedCategory = category;
            this.searchTerm = "";
            this.$refs.categorySelect.isMenuActive = false;
            EventBus.$emit("SELECTED_TRAINING_CATEGORY", category);
        },
        startEditCategory(category) {
            this.editingItem = category;
            this.editName = category.name;
            this.editCategory = true;
        },
        confirmEditCategory(category) {
            if (this.editName.trim()) {
                this.categoryLoading = true;
                externalAPI.updateExternalTrainingCategory(category.id, { name: this.editName.trim() }).then(() => {
                    category.name = this.editName.trim();
                    this.$snotify.success('Category name updated successfully.');
                    this.categoryLoading = false;
                    EventBus.$emit("TRAINING_CATEGORY_UPDATED");
                })
                    .catch(() => {
                        this.$snotify.error(this.cateogryErrorMessage);
                        this.categoryLoading = false;
                        setTimeout(() => {
                            this.$gf.removeBackdrop();
                        }, 300);
                    });
            }
            this.editingItem = null;
        },
        closeEdit() {
            this.editingItem = null;
            this.editName = "";
        },
        deleteCategory(item) {
            this.categoryLoading = true;
            externalAPI.deleteExternalTrainingCategory(item.id).then(() => {
                this.$snotify.success(this.categoryDeleteSuccessMessage);
                this.categoryLoading = false;
                this.categories = this.categories.filter(category => category.id !== item.id);
                EventBus.$emit("TRAINING_CATEGORY_UPDATED");
            }).catch(() => {
                this.$snotify.error(this.cateogryErrorMessage);
                this.categoryLoading = false;
                setTimeout(() => {
                    this.$gf.removeBackdrop();
                }, 300);
            })
        }
    },
    beforeDestroy() {
        EventBus.$off("SELECTED_TRAINING_CATEGORY");
  },
};
</script>

<style scoped>
.category-item {
    display: flex;
    justify-content: space-between;
    padding: 5px;
    align-items: center;
}

button {
    background: none;
    border: none;
    cursor: pointer;
    margin-left: 5px;
}

.category-action-btn {
    display: inline-block;
}

.add-new-category {
    font-weight: 600 !important;
    cursor: pointer;
}

.default-category {
    cursor: not-allowed;
}
.v-progress-circular{
    height: auto !important;
}
</style>